import React from "react";
import { Check } from "lucide-react";
import Reveal from "./Reveal";

const REASONS = [
  {
    title: "Szybka obsługa",
    desc: "Polisę zwykle finalizujemy w dniu zgłoszenia. Bez umawiania na przyszły tydzień.",
  },
  {
    title: "Konkurencyjne ceny",
    desc: "Porównuję oferty kilkunastu towarzystw i wybieram tę najkorzystniejszą dla Ciebie.",
  },
  {
    title: "Ponad 25 towarzystw ubezpieczeniowych w jednym miejscu",
    desc: "Porównujemy wiele możliwości, dzięki czemu nie musisz odwiedzać kilku różnych placówek.",
  },
  {
    title: "Lokalna znajomość rynku",
    desc: "Wiem, jak ubezpieczyć dom drewniany pod lasem, samochód jeżdżący po górskich drogach i firmę z regionu.",
  },
  {
    title: "Pełna dyspozycyjność",
    desc: "Odbieram telefon. Odpisuję na wiadomości. Jeśli trzeba — przyjadę i pomogę przy szkodzie.",
  },
  {
    title: "Bez korporacyjnego żargonu",
    desc: "Tłumaczę warunki polisy po polsku — tak, żebyś naprawdę wiedział, co podpisujesz.",
  },
];

export const WhyMe = () => {
  return (
    <section
      id="dlaczego-ja"
      data-testid="why-me-section"
      className="py-20 md:py-28 bg-forest text-cream relative overflow-hidden"
    >
      {/* Decorative grain */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85'/></filter><rect width='200' height='200' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="container-narrow relative">
        <Reveal>
          <div className="max-w-2xl">
            <div className="text-mustard font-heading font-bold uppercase text-sm tracking-wider mb-3">
              Dlaczego my
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-cream leading-tight">
              6 powodów, dla których klienci<br />
              zostają z nami na lata.
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-x-10 gap-y-7">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 50}>
              <div
                data-testid={`why-reason-${i}`}
                className="flex gap-4"
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-full bg-mustard/15 border border-mustard/30 flex items-center justify-center mt-0.5">
                  <Check size={18} className="text-mustard" strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-cream text-lg mb-1.5">
                    {r.title}
                  </h3>
                  <p className="text-cream/75 text-base leading-relaxed">
                    {r.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyMe;
